import CategoryActor from "./CategoryActor";
import { Actor } from "../../models/Actor_model";
import CategoryWrapper from "../../core/components/CategoryWrapper";

export default function ActorPage() {
  return <CategoryWrapper MainModel={Actor} BoxContent={CategoryActor} />;
}
